const defaultTextValues = {
  sectionTitle: {
    en: 'List'
  },
  listElement: {
    en: '- First List Element'
  },
};

export default defaultTextValues;
